import { __extends } from "tslib";
import React from 'react';
import { compose } from 'redux';
import ContainerSize from '../../../ContainerSize';
import NumberedItemWrapper from '../NumberedItemWrapper';
import SelectableDeviationWrapper from '../SelectableDeviationWrapper';
import DeviationDumbView from '../../../DeviationViews/Dumbo';
import { getDeviationEntityId } from '../../../redux/normalizr/schemas/deviation';
import GallectionDeviationControlButtons from '../GallectionDeviationControlButtons';
import CustomSetDeviationControlButtons from '../CustomSetDeviationControlButtons';
import withSelectedDeviations from '../../_hocs/withSelectedDeviations';
import PremiumFolderIcon from '../PremiumFolderIcon';
import manageableDeviationStyles from './ManageableDeviation.scss';
var enhance = compose(withSelectedDeviations);
var ManageableDeviation = /** @class */ (function (_super) {
    __extends(ManageableDeviation, _super);
    function ManageableDeviation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ManageableDeviation.prototype.render = function () {
        var _this = this;
        var _a = this.props, index = _a.index, deviation = _a.deviation, selectedDeviations = _a.selectedDeviations, isInCustomSet = _a.isInCustomSet;
        var ControlButtons = isInCustomSet
            ? CustomSetDeviationControlButtons
            : GallectionDeviationControlButtons;
        var isAnySelected = !!selectedDeviations.length;
        return (React.createElement(ContainerSize, { className: manageableDeviationStyles['measured-container'] }, function (_a) {
            var width = _a.width, height = _a.height;
            return (React.createElement(SelectableDeviationWrapper, { key: getDeviationEntityId(deviation), deviation: deviation, className: manageableDeviationStyles['deviation-wrapper'] },
                React.createElement(NumberedItemWrapper, { number: index + 1 },
                    React.createElement(DeviationDumbView, { deviation: deviation, width: width, height: height })),
                React.createElement(PremiumFolderIcon, { deviation: deviation, className: manageableDeviationStyles['premium-icon'] }),
                !isAnySelected && (React.createElement("div", { className: manageableDeviationStyles['control-buttons'], onClick: _this.onControlButtonsWrapperClick },
                    React.createElement(ControlButtons, { deviation: deviation })))));
        }));
    };
    ManageableDeviation.prototype.onControlButtonsWrapperClick = function (event) {
        event.stopPropagation();
    };
    return ManageableDeviation;
}(React.Component));
export default enhance(ManageableDeviation);
//# sourceMappingURL=ManageableDeviation.connected.js.map